import router from './router'
import store from './store'
import {
  Message
} from 'element-ui'
import NProgress from 'nprogress' // progress bar
import 'nprogress/nprogress.css' // progress bar style
import {
  getLoginData,
  getRoleId,
  getToken,
  setLoginData
} from '@/utils/auth' // get token from cookie
import getPageTitle from '@/utils/get-page-title'
import {
  getMenuByListID
} from '@/services/role'

NProgress.configure({
  showSpinner: false
}) // NProgress Configuration

const whiteList = ['/login'] // no redirect whitelist

router.beforeEach(async (to, from, next) => {
  // start progress bar
  console.log(getRoleId(),'role');
  NProgress.start()
  document.title = getPageTitle(to.meta.title);
  if (to.meta.requireAuth === false) {
    next();
    return;
  }

  let loginData = getLoginData();
  if (!loginData) {
    next(`/login`);
    return;
  }
  const hasPermission = store.getters && store.getters.roleId;
  if (!hasPermission) {
    var roleId = getRoleId();
    store.dispatch('permission/setRoleId', roleId)
  }
  if (to.meta.permissionRedirect === true) {
    next();
    return;
  }
  if ((to.meta.role.includes(getRoleId()))) {
    next()
    return;
  }
  if (getRoleId() != 5 && to.path == '/home/index') {
    console.log("dsdswww")
    next()
    return;
  }
  if (getRoleId() < 3 && to.path == '/endUserPage/systemUpgrade/index') {
    next()
    return;
  }
  if (getRoleId() != 5 && to.path == '/endUserPage/faultyDevices/index') {
    next()
    return;
  }
  if (getRoleId() < 3 && to.path == '/paramSetPage/index') {
    next()
    return;
  }
  Message({
    type: "error",
    message: "Permission Denied！"
  })
  setLoginData();
  next({
    path: '/login'
  })
  return;



  //
  // // determine whether the user has logged in
  // const hasToken = getToken()
  // if (hasToken) {
  //   const hasPermission =store.getters.permission && store.getters.permission.length>0;
  //   if(!hasPermission){
  //     const ids=await getMenuByListID();
  //     if(!ids || ids.length==0){
  //       Message({type:"error",message:"当前账号未分配权限！"})
  //       setLoginData();
  //       next({path: '/'})
  //       return;
  //     }
  //     store.dispatch('permission/setPermission', ids)
  //   }
  //   if(to.meta.permissionRedirect===true){
  //     next();
  //     return;
  //   }
  //  if(!store.getters.hasPermission(to.meta.id)){
  //
  //     next({path: '/'});
  //    // setLoginData();
  //    // this.$message({type:"error",message:"当前页面无权限访问！"})
  //    // next({path: '/login'});
  //    return;
  //  }
  //   if (to.path === '/login') {
  //     next({ path: '/' })
  //     NProgress.done()
  //   } else {
  //     const hasGetUserInfo = store.getters.name
  //     if (hasGetUserInfo) {
  //       next()
  //     }
  //      await store.dispatch('user/getInfo')
  //         next()
  //
  //     }
  //
  // } else {
  //   /* has no token*/
  //
  //   if (whiteList.indexOf(to.path) !== -1) {
  //     // in the free login whitelist, go directly
  //     next()
  //   } else {
  //     // other pages that do not have permission to access are redirected to the login page.
  //     next(`/login?redirect=${to.path}`)
  //     NProgress.done()
  //   }
  // }
})

router.afterEach(() => {
  // finish progress bar
  NProgress.done()
})
